export default "__VITE_ASSET__eCiKoKK0__"